<template>
  <v-card>
    <v-form
      ref="form"
      v-model="validForm"
    >
      <v-container>
        <v-layout wrap>
          <!-- Project Name -->
          <v-flex
            xs12
            sm6
          >
            <v-text-field
              v-model="project.name"
              :label="$t('name')"
              :error-messages="project.errors.name"
            />
          </v-flex>

          <!-- Description -->
          <v-flex
            xs12
            sm6
          >
            <v-text-field
              v-model="project.description"
              :label="$t('description')"
            />
          </v-flex>

          <!-- Custom Properties -->
          <v-flex
            v-for="customProp in customProperties('project')"
            :key="`custom-prop-${customProp.id}`"
            xs12
            sm6
            md4
            lg3
          >
            <pa-custom-property-field
              v-model="project[customProp.key]"
              :custom-prop="customProp"
            />
          </v-flex>

          <v-flex
            v-if="$can('organization')"
            xs12
            class="text-center"
          >
            <v-btn
              outlined
              small
              :to="{ name: 'organization-fields' }"
            >
              <v-icon left>
                add
              </v-icon>
              {{ $t('add') + ' ' + $t('customFields._') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>

    <v-card-actions>
      <vu-btn-confirm
        v-if="$can('project.delete')"
        color="error"
        :action="$t('delete')"
        :message="$t('deleteConfirm', { what: project.name })"
        :loading="project.deleting"
        :disabled="project.loading || project.deleting || project.isNew()"
        @confirm="deleteProject()"
      >
        <span v-t="'delete'" />
      </vu-btn-confirm>

      <v-btn
        v-t="'cancel'"
        text
        @click="cancel()"
      />

      <v-spacer />

      <v-btn
        v-t="project.isNew() ? 'create' : 'save'"
        color="primary"
        depressed
        :loading="project.loading"
        :disabled="project.loading || project.deleting || !validForm"
        @click="save()"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

import VuBtnConfirm from '@/components/shared/VuBtnConfirm'
import PaCustomPropertyField from '@/components/shared/PaCustomPropertyField'
import ProjectComponent from '@/mixins/ProjectComponent'

export default {
  name: 'ProjectEdit',
  components: {
    VuBtnConfirm,
    PaCustomPropertyField
  },
  mixins: [ ProjectComponent ],
  data () {
    return {
      validForm: true
    }
  },
  computed: {
    ...mapGetters('organizations', [ 'customProperties' ])
  },
  methods: {
    async save () {
      if (this.project.isNew()) {
        this.project.users.push(this.$currentUser.id)
      }
      await this.project.save()
      this.$router.push({ name: 'project-details', params: { name: this.project.id } })
    },
    cancel () {
      this.project.reset()
    },
    async deleteProject () {
      try {
        await this.project.delete()
        this.$router.push({ name: 'projects' })
      } catch (err) { }
    }
  }
}
</script>

<style lang="scss">
.img-inputer {
  border-radius: 2px !important;

  .img-inputer__preview-box {
    background: inherit;
    text-align: center;

    .img-inputer__preview-img {
      width: auto;
    }
  }
}
</style>
